export default "__VITE_ASSET__Cow8qLyv__"